import { renderToString, h, Fragment, renderToDom } from '../../../lib/vdom.js';
import About from './About.jsx';
import Contact from './Contact.jsx';
import ImageDialog from './ImageDialog.jsx';
import Intro, { initIntro } from './Intro.jsx';
import Navbar, { initNavbar, type NavbarLink } from './Navbar.jsx';
import Portfolio, { initPortfolio } from './Portfolio.jsx';
import Services from './Services.jsx';
import Tech from './Tech.jsx';
import Testimonials from './Testimonials.jsx';

export default function Home() {
  const links: NavbarLink[] = [
    // {
    //   label: 'Blog',
    //   href: '/blog',
    // },
    {
      label: 'Services',
      href: '/#services',
    },
    {
      label: 'Portfolio',
      href: '/#portfolio',
    },
    {
      label: 'About',
      href: '/#about',
    },
    {
      label: 'Contact',
      href: '/#contact',
      primary: true,
    },
  ];
  return (
    <>
      <Navbar links={links} transparentAtTop />
      <Intro />
      <Services />
      <Portfolio />
      <About />
      <Testimonials />
      <Tech />
      <Contact forHomePage />
      <ImageDialog />
    </>
  );
}

function onLoad() {
  // const vnode = <Home />;
  // document.getElementById('app')!.appendChild(renderToDom(vnode)!);
  initNavbar();
  initIntro();
  initPortfolio();
  // document.querySelector('.logo')!.onclick = e => {
  //   window.location.href = ;
  //   e.preventDefault();
  //   // console.log('XXX', process?.env?.NODE_ENV);
  // };
}

if (typeof window !== 'undefined') {
  // Runs after the HTML has been parsed, before images and other resources are loaded.
  document.addEventListener('DOMContentLoaded', onLoad);
}
